// Prepend all the strings with dev- to avoid collision with the real routes.
import { html } from 'lit';

export const DevRoutes = {
  Home: 'dev-home',
  PushTool: 'push-tool'
};

export const devRoutes = {
  [DevRoutes.Home]: {
    route: '/dev',
    view: () => import('./components/views/dev-home.ts'),
    title: 'Dev Home',
    render: () => html`<dev-home></dev-home>`
  },
  [DevRoutes.PushTool]: {
    route: '/dev/push',
    view: () => import('./components/views/push-tool-view.ts'),
    title: 'Push Notifications Tool',
    render: () => html`<push-tool-view></push-tool-view>`
  }
};